import React from "react";
import ResortCard from "./ResortCard.jsx";
// Removed Pagination and Stack imports

const ResortList = ({ filters, hotelData }) => {
  // Keep your existing filtering logic
  const filteredResorts = hotelData.filter((hotel) => {
    if (!Array.isArray(hotel.rooms) || hotel.rooms.length === 0) return true;

    const matchesRoom =
      filters.priceRange?.length || filters.roomViews?.length
        ? hotel.rooms.some((room) => {
            const price = Number(room.price_per_night) || 0;

            if (
              filters.priceRange?.length === 2 &&
              (price < filters.priceRange[0] || price > filters.priceRange[1])
            ) return false;

            if (
              filters.roomViews?.length > 0 &&
              !filters.roomViews.includes(room.room_type)
            ) return false;

            return true;
          })
        : true;

    if (!matchesRoom) return false;

    if (filters.average_rating) {
      if ((hotel.average_rating ?? 0) < filters.average_rating) return false;
    }

    if (filters.amenities?.length > 0) {
      if (!Array.isArray(hotel.amenities)) return false;
      const hotelAmenities = hotel.amenities.map((a) => a.name?.toLowerCase());
      if (!filters.amenities.every((a) => hotelAmenities.includes(a.toLowerCase()))) {
        return false;
      }
    }

    return true;
  });

  return (
    <div className="resort-list" style={{ width: "100%" }}>
      {filteredResorts.length > 0 ? (
        // ✅ Render ALL filtered items. Hotel_page handles the infinite scroll fetching.
        filteredResorts.map((hotel) => (
          <ResortCard key={hotel.id} resort={hotel} />
        ))
      ) : (
        <p style={{ textAlign: "center" }}>No resorts found.</p>
      )}
    </div>
  );
};

export default ResortList;